export const ErrorTypes = {
  LoginFailure: "loginFailure",
  NotCanvasAdmin: "notCanvasAdmin",
  DifferentSfmcOrg: "differentSfmcOrg",
  InvalidJwt: "invalidJwt",
  UnknownError: "unknownError",
};

class CustomError extends Error {
  title?: string;
  supportMessage?: string;
}

export const createError = (
  errorType?: string,
  errorMessage?: string,
  supportMessage?: string
) => {
  const error = new CustomError();
  if (errorMessage) {
    error.message = errorMessage;
  } else {
    error.message =
      "Something went wrong while trying to connect your Salesforce Marketing Cloud to your Bluedot account.";
  }
  if (
    Object.values(ErrorTypes).includes(errorType) &&
    errorType !== ErrorTypes.UnknownError
  ) {
    error.name = errorType;
    error.title = "Unable to connect";
    error.supportMessage = supportMessage ? supportMessage : "Please try again";
  } else {
    error.name = ErrorTypes.UnknownError;
    error.title = "Error";
    error.supportMessage = "Please try again";
  }
  return error;
};

export const throwNotCanvasAdminError = () => {
  const errorMessage =
    "Your user does not have permission to connect Salesforce Marketing Cloud to your Bluedot account.";
  const supportMessage = "Please contact your Canvas admin and retry.";
  throw createError(ErrorTypes.NotCanvasAdmin, errorMessage, supportMessage);
};

export const throwDifferentSfmcOrgError = () => {
  const errorMessage =
    "The Canvas account you provided is already linked to another Salesforce Marketing Cloud account.";
  const supportMessage =
    "Please contact our Support Team to resolve the issue.";
  throw createError(ErrorTypes.DifferentSfmcOrg, errorMessage, supportMessage);
};

export const createInvalidJwtError = () => {
  const errorMessage =
    "The details received from Salesforce Marketing Cloud do not match the expected format.";
  const supportMessage =
    "Please contact our Support Team to resolve the issue.";
  return createError(ErrorTypes.InvalidJwt, errorMessage, supportMessage);
};

export const throwInvalidLoginError = (errorMessage) => {
  throw createError(ErrorTypes.LoginFailure, errorMessage);
};
